import React from 'react';
import { Alert, AlertType } from '../../../components/Alert';

interface PropTypes {
  handleClose: () => void;
}

export default function CalendarMissingPermissionsAlert(props: PropTypes) {
  return (
    <Alert type={AlertType.Danger} clearable={true} onClose={props.handleClose}>
      {"We weren't able to connect your calendar due to missing permissions. "}
      <a
        href={
          'https://help.screenloop.com/en/articles/11364385-syncing-google-calendar-integration-status'
        }
        target='_blank'
        className='text-info'
        rel='noreferrer'
      >
        Follow this quick guide
      </a>
      {' to reconnect it in just a few steps.'}
    </Alert>
  );
}
